import { ProjectGroupFilter, ProjectGroupsQuery, ProjectGroupsQueryVariables } from '__generated__/graphql';
import { projectGroupsQuery } from 'components/domain/project-group/ProjectGroupPicker/project-group-picker-queries';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { useCallback } from 'react';
import { NonNullArrayField } from 'types/util/NonNullArrayField';

export type ProjectGroupPickerItem = NonNullArrayField<ProjectGroupsQuery['projectGroups']>;

export interface UseProjectGroupPickerDataOptions {
  excludeIds?: string[];
}

export function useProjectGroupPickerData({ excludeIds }: UseProjectGroupPickerDataOptions = {}) {
  const graphqlClient = useGraphQLClient();

  const fetchPage = useCallback(
    async (after: string | null, first: number): Promise<ProjectGroupPickerItem[]> => {
      const filter: ProjectGroupFilter = { deletedOn: { isNull: true } };
      if (excludeIds && excludeIds.length > 0) {
        filter.id = { doesNotContain: excludeIds };
      }
      const result = await graphqlClient.request<ProjectGroupsQuery, ProjectGroupsQueryVariables>({
        document: projectGroupsQuery,
        variables: { after, first, filter },
      });

      return result.projectGroups ?? [];
    },
    [graphqlClient, excludeIds]
  );

  const fetchSelected = useCallback(
    async (ids: string[]): Promise<ProjectGroupPickerItem[]> => {
      const result = await graphqlClient.request<ProjectGroupsQuery, ProjectGroupsQueryVariables>({
        document: projectGroupsQuery,
        variables: { filter: { id: { contains: ids } } },
      });

      return result.projectGroups ?? [];
    },
    [graphqlClient]
  );

  return { fetchPage, fetchSelected };
}
